<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/D8VN3Y/tc-custom/cover.jpg?1700065801004?1706297156157" alt="This image is the cover for the book Petroleum Refining in Nontechnical Language"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Petroleum Refining in Nontechnical Language
      </h1>
      <p class="bookDescription body article font2">
        <p>For 45 years, William Leffler's Petroleum Refining in Nontechnical Language has been the go-to best seller for anyone needing to know the fundamentals of refining.  Each chapter was carefully written in nontechnical language to give the reader a basic understanding of the refining industry.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        William L. Leffler
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      PennWell
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?328463b4